import React, { Component } from 'react'


class Home extends Component {
    render() {
        return (
          <div>
<section id="wrapper">
  <div className="login-register" style={{ backgroundImage: `url("assets/images/back_globe.jpg")`}}>
    <div className="lgtop"><a href="https://ascendant.world/" target='_blank'><img src="assets/images/ascendant-logo.png" height="50"/></a></div>
   
     <div className="container mt-5"> 
      <div className="afx-blue f-24 mb-4">Payee Intel</div>
      <div className="afx-txt f-14">
        <p>Welcome to Payee Intel by Ascendant.</p>
        <p>Payee Intel is our vendor onboarding portal.</p>
        <p>Please access Payee Intel through the registration email sent by Ascendant.</p>
        <p>For any questions, please contact us at <a href="mailto:info@ascendant.world">info@ascendant.world.</a></p>
        <p></p>
      </div>
     </div>
  </div>

  

</section>
<div className="foot_home"><img src="assets/images/bottom_footer.svg" width="1900px"/>
  </div>

            </div>
        )
    }
}

export default Home
